angular.module('cerberus.account')
    .directive('nimOrgAvailable', function($http, apiPath) {
        return {
            require : 'ngModel',
            link : function($scope, element, attrs, ngModel) {
                ngModel.$asyncValidators.nimOrgAvailable = function(name) {
                    valid(false);
                    loading(true);
                    return $http.get(apiPath + 'organizations/name/available?name='+ name).then(
                        function(value) {
                            valid(value.data.DATA);
                            loading(false);
                        },
                        function() {
                            valid(false);
                            loading(false);
                        }
                    );
                };
                ////////////////////
                function valid(bool) {
                    ngModel.$setValidity('record-unavailable', bool);
                }

                function loading(bool) {
                    ngModel.$setValidity('record-loading', !bool);
                }
            }
        };
    })
;